import { ChangeEvent } from 'react';

import { Button } from '@/components/ui/button';

interface AddWebApplicationFormProps {
  onTextChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  textInput: string;
  onOpenImport: () => void;
}

export const AddWebApplicationForm = ({
  onTextChange,
  textInput,
  onOpenImport,
}: AddWebApplicationFormProps) => {
  return (
    <div className="flex flex-col gap-2">
      {/* Text Input Section */}
      <div className="flex flex-col gap-2">
        <h3 className="text-lg font-bold">Add Web Applications</h3>
        <p className="text-chariot-text-secondary text-sm">
          Enter one per line:
        </p>
        <textarea
          className="bg-chariot-background-primary border-chariot-stroke text-chariot-text-primary focus:border-chariot-brand-primary h-32 rounded-lg border-2 p-3 font-mono text-sm focus:outline-hidden disabled:cursor-not-allowed disabled:opacity-50"
          placeholder={`https://app.example.com\nhttps://api.example.com`}
          value={textInput}
          onChange={onTextChange}
          data-testid="webapplication-url-input"
        />
      </div>

      {/* Divider */}
      <p className="text-chariot-text-secondary text-center text-sm">or</p>

      {/* Import Button Section */}
      <div className="flex flex-col gap-2">
        <Button
          onClick={onOpenImport}
          variant="secondary"
          className="w-full"
        >
          Import from File
        </Button>
        <p className="text-chariot-text-secondary text-center text-xs">
          Import web application URLs from a file
        </p>
      </div>
    </div>
  );
};
